export const sortASC = (a: Date | string, b: Date | string) => {
  if (a < b) {
    return -1
  } else if (a > b) {
    return 1
  } else {
    return 0
  }
}
